import { isNumber, round } from 'lodash';
import { evaluate } from 'mathjs';

function solveExpression(expression, variables) {
  try {
    return round(evaluate(expression, variables), 4);
  } catch (error) {
    return 0;
  }
}

function getVariablesByPayroll({
  prVariables = {},
  PR_code = '',
  variables = {}
}) {
  const res = {};

  for (const key of Object.keys(prVariables)) {
    res[key] = prVariables[key]?.[PR_code]
      ? isNumber(prVariables[key][PR_code])
        ? prVariables[key][PR_code]
        : solveExpression(prVariables[key][PR_code], variables)
      : 0;
  }

  return res;
}

export default getVariablesByPayroll;
